import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A8472
 *
 * @param {SvgIconProps} props - svg props
 */
export const RouteIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M15.9707 9.28076L17.9391 6.95221L15.959 5.32195C15.7923 5.18468 15.8663 4.91482 16.0798 4.88188L21.7736 4.00297C21.9177 3.98072 22.0502 4.08606 22.061 4.2315L22.4993 10.1241C22.5155 10.3421 22.264 10.4744 22.0935 10.3376L20.037 8.68688L17.9049 11.3516C17.3356 12.0632 16.4737 12.4774 15.5624 12.4774H14.7188C14.4365 12.4774 14.1674 12.3581 13.9778 12.1489L12.3997 10.4075C12.2541 10.2468 12.3681 9.98958 12.5849 9.98958H14.4433C15.0319 9.98958 15.5907 9.73028 15.9707 9.28076ZM1.5 10.4725V11.9591C1.5 12.2352 1.72386 12.4591 2 12.4591H7.92809C8.21007 12.4591 8.47894 12.5781 8.66848 12.7869L12.9514 17.5045L11.3834 18.9941C11.2284 19.1413 11.3178 19.4026 11.5305 19.4241L17.2263 19.9986C17.384 20.0145 17.5165 19.8815 17.5 19.7238L16.9305 14.2795C16.9089 14.0733 16.66 13.9815 16.5096 14.1243L14.9145 15.6396L10.6049 10.6632C10.2251 10.2246 9.67337 9.97253 9.09307 9.97253H2C1.72386 9.97253 1.5 10.1964 1.5 10.4725Z' fill={color}/>
        </SvgIcon>
    )
}

export default RouteIcon
